// This file is autogenerated. Any changes will be overwritten.

import useUID from '../../../hooks/useUID';

export const set = 'streamline';

export const name = 'warn-solid';

export const Component = () => {
  const maskId = useUID();

  return (
    <>
      <defs>
        <mask id={maskId} fill='#000' stroke='#000' strokeLinecap='round'>
          <path fill='#fff' stroke='#fff' d='M0 0h18v18H0z' />
          <path d='M9 11V6' />
          <circle cx='9' cy='14' r='.25' />
        </mask>
      </defs>
      <path
        fill='currentColor'
        stroke='currentColor'
        d='M10.153 1.718a1.284 1.284 0 0 0-2.305 0L1.11 15.441A1.081 1.081 0 0 0 2.083 17H15.92a1.08 1.08 0 0 0 .971-1.56L10.153 1.719Z'
        mask={`url(#${maskId})`}
      />
    </>
  );
};

export const viewBox = '0 0 18 18';
